import { Navigate } from "react-router-dom";
import type { ChatTurnProps } from "../../types/chat";
import { getActiveLoanScreen } from "./activeLoanScreen";

export function ActiveLoanTurn(props: ChatTurnProps) {
  return <Navigate to={getActiveLoanScreen(props)} replace />;
}
